module.exports = __webpack_public_path__ + "img/pg.f774fad8.svg";